import { Paragraph, Show, tokens } from '@welbe/web-design-system';
import { FiInfo } from 'react-icons/fi';
import { GoDotFill } from 'react-icons/go';
import { reverseDate } from 'Views/HealthRiskAssessment/HealthRiskAssessment.functions';
import { ActivitiesTypes } from 'Views/HealthRiskAssessment/HealthRiskAssessment.types';
import {
	ActivityMessageContainer,
	Container,
	DateSection,
	ElementsForm,
	Empty,
	ExamItemSection,
	ExamsForm,
	ExamsSection,
	PanelsContainer,
} from './RightSidePanel.styles';

type RightSidePanelProps = {
	empty: boolean;
	activity: ActivitiesTypes | undefined;
};

export const RightSidePanel = ({ empty, activity }: RightSidePanelProps) => {
	const assigned = activity?.activityAssigned;
	const showExams = activity?.showExams;
	const exams = activity?.settings?.exams;

	if (empty) {
		return (
			<Empty>
				<Paragraph fontStyle="italic">Seleccione una actividad</Paragraph>
			</Empty>
		);
	}

	return (
		<Container>
			<Paragraph fontSize="16px" fontWeight="600" color={tokens.color_primary}>
				Detalles
			</Paragraph>
			<PanelsContainer>
				<ElementsForm $disabled={!assigned}>
					<div>
						<Paragraph
							fontWeight="700"
							fontSize="12px"
							color={tokens.color_primary}
						>
							Nombre de la actividad
						</Paragraph>
						<Paragraph fontWeight="500" fontSize="16px">
							{activity?.settings?.name || ''}
						</Paragraph>
					</div>
					<div>
						<Paragraph
							fontWeight="700"
							fontSize="12px"
							color={tokens.color_primary}
						>
							Descripción
						</Paragraph>
						<Paragraph fontWeight="500" fontSize="16px">
							{activity?.settings?.description || ''}
						</Paragraph>
					</div>
					<DateSection>
						<div>
							<Paragraph
								fontWeight="700"
								fontSize="12px"
								color={tokens.color_primary}
							>
								Fecha inicio
							</Paragraph>
							<Paragraph fontWeight="500" fontSize="16px">
								{reverseDate(activity?.settings?.dateStart)}
							</Paragraph>
						</div>
						<Show when={!activity?.settings?.isSingleDay} fallback={null}>
							<div>
								<Paragraph
									fontWeight="700"
									fontSize="12px"
									color={tokens.color_primary}
								>
									Fecha fin
								</Paragraph>
								<Paragraph fontWeight="500" fontSize="16px">
									{reverseDate(activity?.settings?.dateEnd)}
								</Paragraph>
							</div>
						</Show>
					</DateSection>
				</ElementsForm>
				<Show when={Boolean(showExams)} fallback={null}>
					<ExamsForm>
						<Paragraph
							fontSize="16px"
							fontWeight="600"
							color={tokens.color_primary}
						>
							Sigue los estudios para esta actividad
						</Paragraph>

						<ExamsSection>
							<Show when={!exams?.length} fallback={null}>
								<ActivityMessageContainer>
									<FiInfo color={tokens.color_gray_dark} fontSize={12} />
									<Paragraph fontSize="12px" fontStyle="italic">
										No hay estudios para esta actividad
									</Paragraph>
								</ActivityMessageContainer>
							</Show>

							{exams?.map((exam) => (
								<ExamItemSection key={exam.id}>
									<GoDotFill color={tokens.color_primary} fontSize={10} />
									<Paragraph fontSize="14px" fontWeight="600">
										{exam.name}
									</Paragraph>
								</ExamItemSection>
							))}
						</ExamsSection>
					</ExamsForm>
				</Show>
			</PanelsContainer>
		</Container>
	);
};
